import PropTypes from "prop-types";
import React from "react";
import { multilanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import LanguageCurrencyChanger from "./LanguageCurrencyChanger";

const HeaderTop = ({
    currentLanguageCode,
    dispatch,
    borderStyle,
    strings,
    login
}) => {
    return (
        <div
            className={`header-top-wap ${borderStyle === "fluid-border" ? "border-bottom" : ""
                }`}
        >
            <LanguageCurrencyChanger
                currentLanguageCode={currentLanguageCode}
                dispatch={dispatch}
                login={login}
            />
            <div className="header-offer">
                {strings['freeShippingInfo']}
            </div>
        </div>
    );
};

HeaderTop.propTypes = {
    borderStyle: PropTypes.string,
    currentLanguageCode: PropTypes.string,
    dispatch: PropTypes.func,
    strings: PropTypes.object
};

const mapStateToProps = state => {
    return {
        login: state.login
    };
};

export default connect(
    mapStateToProps,
    {

    }
)(multilanguage(HeaderTop));
